'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const getRotationDegrees = (prizeNumber, numberOfPrizes, prizeAngle) => {
  const degreesPerPrize = 360 / numberOfPrizes;
  const initialRotation = prizeAngle + degreesPerPrize / 2;
  const randomDifference = (-1 + Math.random() * 2) * degreesPerPrize * 0.35;
  const prizeRotation = degreesPerPrize * (numberOfPrizes - prizeNumber) - initialRotation + randomDifference;
  return numberOfPrizes - prizeNumber > numberOfPrizes / 2 ? -360 + prizeRotation : prizeRotation;
};
const clamp = (min, max, val) => Math.min(Math.max(min, +val), max);
const calculateImageSize = (width, height, newWidth, defaultWidth) => {
  if (!width || !height)
    return;
  const ratio = width / height;
  const calcWidth = newWidth || defaultWidth;
  const calcHeight = calcWidth / ratio;
  return { width: calcWidth, height: calcHeight };
};
const makeClassKey = (length) => {
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

exports.calculateImageSize = calculateImageSize;
exports.clamp = clamp;
exports.getRotationDegrees = getRotationDegrees;
exports.makeClassKey = makeClassKey;
